import React, { useState, useEffect, Component } from 'react';
import axios from 'axios';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import TableView from '../../TableView';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const ManifestDetails = ({ onhandleBLNunber, onhadlePlaceofDelivery, onhadleMasterBL, onhadleHouseBL, onhadleBLDate, onhadleConsignee, onhadleNotyfyParty, onhadleDeliverGoods,
    onhadlePlaceOfReceipt, onhadlePreCarrageBy, onhadleVesCode, onhadleVesDesc, onhadlevoyCode, onhadlePolCode, onhadleVoyDesc, onhadlepodCode, onhadlePolDesc, onhadlepodDesc, onhadleFinalDestination, onhadleGrossWeight, onhadleNoOfCont, onhadleMesurement, onhadleNoOfContInWords, onhadleShipper }) => {
    // const [baseUrl, setBaseUrl] = useState('http://127.0.0.1:8000/api/');
    const [baseUrl, setBaseUrl] = useState('http://mol.evolve-demo.com/api/');
    const [pageComponent, setPageComponent] = useState('airexportbl');
    const [blNumList, setBlNumList] = useState(undefined);
    const [selectedBLNO, setSelectedBLNO] = useState('');

    const [firstFlightDateTextBoxes, setFirstFlightDateTextBoxes] = useState(1);
    const [firstFlightDate, setFirstFlightDate] = useState(['']);
    const [flightDateList, setFlightDateList] = useState([])


    const [houseBL, setHouseBL] = useState('');
    const [nowHouseBL, setNowHouseBL] = useState('');
    const [houseBLOn, setHouseBLOn] = useState(false);

    const [bLDate, setBLDate] = useState('');
    const [nowBLDate, setNowBLDate] = useState('');
    const [bLDateOn, setBLDateOn] = useState(false);

    const [vesCode, setVesCode] = useState('vessel code');
    const [vesDesc, setVesDesc] = useState('vessel Description');
    const [voyCode, setVoyCode] = useState('Voyage code');
    const [voyDesc, setVoyDesc] = useState('Voyage Description');
    const [polCode, setPolCode] = useState('Port looding code');
    const [polDesc, setPolDesc] = useState('Port looding Description');
    const [podCode, setPodCode] = useState('Port looding code');
    const [podDesc, setPodDesc] = useState('Port looding Description');

    const [placeofDelivery, setPlaceofDelivery] = useState('');
    const [nowPlaceofDelivery, setNowPlaceofDelivery] = useState('');
    const [placeofDeliveryOn, setPlaceofDeliveryOn] = useState(false);

    const [preCarrageBy, setPreCarrageBy] = useState('');
    const [NowPreCarrageBy, setNowPreCarrageBy] = useState('');
    const [preCarrageByOn, setPreCarrageByOn] = useState(false);

    const [placeOfReceipt, setPlaceOfReceipt] = useState('');
    const [NowPlaceOfReceipt, setNowPlaceOfReceipt] = useState('');
    const [placeOfReceiptOn, setPlaceOfReceiptOn] = useState(false);

    const [finalDestination, setFinalDestination] = useState('');
    const [NowFinalDestination, setNowFinalDestination] = useState('');
    const [finalDestinationOn, setFinalDestinationOn] = useState(false);

    const [grossWeight, setGrossWeight] = useState('');
    const [NowgrossWeight, setNowGrossWeight] = useState('');
    const [grossWeightOn, setGrossWeightOn] = useState(false);

    const [noOfCont, setNoOfCont] = useState('');
    const [nownoOfCont, setNowNoOfCont] = useState('');
    const [noOfContOn, setNoOfContOn] = useState(false);

    const [mesurement, setMesurement] = useState('');
    const [nowmesurement, setNowMesurement] = useState('');
    const [mesurementOn, setMesurementOn] = useState(false);

    const [shipper, setShipper] = useState('');
    const [nowshipper, setNowShipper] = useState('');
    const [shipperOn, setShipperOn] = useState(false);

    const [noOfContInWords, setNoOfContInWords] = useState('');
    const [nowNoOfContInWords, setNowNoOfContInWords] = useState('');
    const [noOfContInWordsOn, setNoOfContInWordsOn] = useState(false);

    const [consignee, setConsignee] = useState('');
    const [nowConsignee, setNowConsignee] = useState('');
    const [consigneeOn, setConsigneeOn] = useState(false);

    const [notyfyParty, setNotyfyParty] = useState('');
    const [nowNotyfyParty, setNowNotyfyParty] = useState('');
    const [notyfyPartyOn, setNotyfyPartyOn] = useState(false);

    const [deliverGoods, setDeliverGoods] = useState('');
    const [nowDeliverGoods, setNowDeliverGoods] = useState('');
    const [deliverGoodsOn, setDeliverGoodsOn] = useState(false);



    try {
        useEffect(() => {
            fetch(`http://mol.evolve-demo.com/api/airexportbl/getBLNO`)
                .then(response => response.json())
                .then(data => {
                    setBlNumList(data.blno);
                    console.log(data);
                })
        }, []);
    } catch (error) {
        if (error.response && error.response.status === 429) {
        } else {
            console.error(error);
        }
    }

    const houseBLVal = (e) => {
        setHouseBLOn(true)
        setNowHouseBL(e)
    }

    const dateVal = (e) => {
        setBLDateOn(true)
        setNowBLDate(e)
    }
    const placeofDeliveryVal = (e) => {
        setPlaceofDeliveryOn(true)
        setNowPlaceofDelivery(e)
    }
    const preCarrageByVal = (e) => {
        setPreCarrageByOn(true)
        setNowPreCarrageBy(e)
    }
    const placeOfReceiptVal = (e) => {
        setPlaceOfReceiptOn(true)
        setNowPlaceOfReceipt(e)
    }
    const finalDestinationVal = (e) => {
        setFinalDestinationOn(true)
        setNowFinalDestination(e)
    }
    const grossWeightVal = (e) => {
        setGrossWeightOn(true)
        setNowGrossWeight(e)
    }
    const noOfContVal = (e) => {
        setNoOfContOn(true)
        setNowNoOfCont(e)
    }
    const mesurementVal = (e) => {
        setMesurementOn(true)
        setNowMesurement(e)
    }
    const shipperVal = (e) => {
        setShipperOn(true)
        setNowShipper(e)
    }
    const noOfContInWordsVal = (e) => {
        setNoOfContInWordsOn(true)
        setNowNoOfContInWords(e)
    }
    const consigneeVal = (e) => {
        setConsigneeOn(true)
        setNowConsignee(e)
    }
    const notyfyPartyVal = (e) => {
        setNotyfyPartyOn(true)
        setNowNotyfyParty(e)
    }
    const deliverGoodsVal = (e) => {
        setDeliverGoodsOn(true)
        setNowDeliverGoods(e)
    }


    const selectBooking = (id) => {



        let blNow = id;
        console.log(blNow);
        // setSelectedBLNO(blNow);
        // setHouseBL('');
        // setBLDate('');
        // setVesCode('vessel code');
        // setVesDesc('vessel Description');
        // setVoyCode('Voyage code');
        // setVoyDesc('Voyage Description');
        // setPolCode('Port looding code');
        // setPolDesc('Port looding Description');
        // setPodCode('Port looding code');
        // setPodDesc('Port looding Description');
        // setPlaceofDelivery('');
        // setPreCarrageBy('');
        // setPlaceOfReceipt('');
        // setFinalDestination('');
        // setGrossWeight('');
        // setNoOfCont('');
        // setMesurement('');
        // setShipper('');
        // setNoOfContInWords('');
        // setConsignee('');
        // setNotyfyParty('');
        // setDeliverGoods('');
        // fetch(`${baseUrl}${pageComponent}/show/${blNow}`)
        //     .then(response => response.json())
        //     .then(data => {
        //         onhandleBLNunber(data.expbl.id)
        //         setHouseBL(data.expbl.HouseBLNo)
        //         let bldate = data.expbl.BLDate.split(' ')[0]
        //         setBLDate(bldate)
        //         setVesCode(data.expbl.VesCode)
        //         setVesDesc(data.expbl.VesDesc)
        //         setVoyCode(data.expbl.VoyCode)
        //         setVoyDesc(data.expbl.VoyDesc)
        //         setPolCode(data.expbl.POLCode)
        //         setPolDesc(data.expbl.POLDesc)
        //         setPodCode(data.expbl.PODCode)
        //         setPodDesc(data.expbl.PODDesc)
        //         setPlaceofDelivery(data.expbl.PlaceOfDelivery)
        //         setPlaceOfReceipt(data.expbl.PlaceOfReceipt)
        //         setPreCarrageBy(data.expbl.PreCarrageBy)
        //         setFinalDestination(data.expbl.FinalDestination)
        //         setGrossWeight(data.expbl.GrossWeight)
        //         setNoOfCont(data.expbl.NoOfCont)
        //         setMesurement(data.expbl.Mesurement)
        //         setNoOfContInWords(data.expbl.NoOfContInWords)
        //         setShipper(data.expbl.Shipper)
        //         setConsignee(data.expbl.Consignee)
        //         setNotyfyParty(data.expbl.NotyfyParty)
        //         setDeliverGoods(data.expbl.DeliverGoods)
        //     })
        //     .catch(error => {
        //         console.error(error);
        //     });

    }

    onhadlePlaceofDelivery(nowPlaceofDelivery !== '' ? nowPlaceofDelivery : placeofDelivery);
    onhadleMasterBL(selectedBLNO);
    onhadleHouseBL(nowHouseBL !== '' ? nowHouseBL : houseBL);
    onhadleBLDate(nowBLDate !== '' ? nowBLDate : bLDate);
    onhadleVesCode(vesCode)
    onhadleVesDesc(vesDesc)
    onhadlevoyCode(voyCode)
    onhadleVoyDesc(voyDesc)
    onhadlePolCode(polCode)
    onhadlePolDesc(polDesc)
    onhadlepodCode(podCode)
    onhadlepodDesc(podDesc)
    onhadlePlaceOfReceipt(NowPlaceOfReceipt !== '' ? NowPlaceOfReceipt : placeOfReceipt)
    onhadlePreCarrageBy(NowPreCarrageBy !== '' ? NowPreCarrageBy : preCarrageBy)
    onhadleFinalDestination(NowFinalDestination !== '' ? NowFinalDestination : finalDestination)
    onhadleGrossWeight(NowgrossWeight !== '' ? NowgrossWeight : grossWeight)
    onhadleNoOfCont(nownoOfCont !== '' ? nownoOfCont : noOfCont)
    onhadleMesurement(nowmesurement !== '' ? nowmesurement : mesurement)
    onhadleNoOfContInWords(nowNoOfContInWords !== '' ? nowNoOfContInWords : noOfContInWords)
    onhadleShipper(nowshipper !== '' ? nowshipper : shipper)
    onhadleConsignee(nowConsignee !== '' ? nowConsignee : consignee)
    onhadleNotyfyParty(nowNotyfyParty !== '' ? nowNotyfyParty : notyfyParty)
    onhadleDeliverGoods(nowDeliverGoods !== '' ? nowDeliverGoods : deliverGoods)

    // const handleInputChange = (index, value) => {
    //     const newInputValues = [...inputValues];
    //     newInputValues[index] = value;
    //     setInputValues(newInputValues);
    //     addNewTextBox();
    //     console.log(inputValues);
    // };

    const flightFirstDateSet = (index, value, i, r) => {
        // handleflightTwoChange()
        // handleflightOneChange()

        const newInputValues = [...firstFlightDate];
        newInputValues[index] = value;
        setFirstFlightDate(newInputValues);
        addNewTextBox()

        const newFirstFlightNo = [...flightDateList];
        newFirstFlightNo[index][i] = index;
        newFirstFlightNo[index][r] = value;
        setFlightDateList(newFirstFlightNo);

    }



    const addNewTextBox = () => {
        if (firstFlightDate[firstFlightDate.length - 1] !== '') {
            setFirstFlightDateTextBoxes(firstFlightDateTextBoxes + 1);
            setFirstFlightDate([...firstFlightDate, '']);
        }

        console.log(flightDateList);
    };

    return (
        <Container>
            <ToastContainer autoClose={2000} />
            <Row>
                <Col>
                    <Form className='mt-4 bottom-border pb-3' >
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>BL Number</Form.Label>
                                    <Form.Select aria-label="" onChange={e => { selectBooking(e.target.value) }}>
                                        <option value=""></option>
                                        <>
                                            {
                                                Array.isArray(blNumList) ? blNumList.map((bLItem, id) => (
                                                    <option value={bLItem.id} key={bLItem.id}>{bLItem.BLNo}</option>

                                                )) : ''
                                            }
                                        </>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Booking No </Form.Label>
                                    <Form.Control type="text" placeholder="House BL NO" autoComplete="off" name="Hbl" value={nowHouseBL ? nowHouseBL : houseBLOn == false ? houseBL : ''} onChange={e => houseBLVal(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>OF</Form.Label>
                                    <Form.Control type="date" placeholder="" autoComplete="off" name="date" value={nowBLDate ? nowBLDate : bLDateOn == false ? bLDate : ''} onChange={e => dateVal(e.target.value)} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label className="">Vessel</Form.Label><br />
                                    <Form.Label className="printted-label">{vesCode}</Form.Label>
                                    <Form.Label className='printted-label ms-3'>{vesDesc}</Form.Label>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label className="">Voyage</Form.Label><br />
                                    <Form.Label className="printted-label">{voyCode}</Form.Label>
                                    <Form.Label className="ms-3 printted-label">{voyDesc}</Form.Label>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label className="">Poprt of Loading</Form.Label><br />
                                    <Form.Label className="printted-label">{polCode} </Form.Label>
                                    <Form.Label className="ms-3 printted-label">{polDesc}</Form.Label>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label className="">Port of disch</Form.Label><br />
                                    <Form.Label className="printted-label">{podCode} </Form.Label>
                                    <Form.Label className="ms-3 printted-label">{podDesc}</Form.Label>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Place Of Delivery</Form.Label>
                                    <Form.Control type="text" placeholder="" value={nowPlaceofDelivery ? nowPlaceofDelivery : placeofDeliveryOn == false ? placeofDelivery : ''} onChange={e => placeofDeliveryVal(e.target.value)} autoComplete="off" name="date" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Place Of Looding</Form.Label>
                                    <Form.Control type="text" autoComplete="off" value={NowPlaceOfReceipt ? NowPlaceOfReceipt : placeOfReceiptOn == false ? placeOfReceipt : ''} onChange={e => placeOfReceiptVal(e.target.value)} placeholder="" name="Vessel" />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Serial No</Form.Label>
                                    <Form.Control type="text" placeholder="" value={NowPreCarrageBy ? NowPreCarrageBy : preCarrageByOn == false ? preCarrageBy : ''} onChange={e => preCarrageByVal(e.target.value)} autoComplete="off" name="" />
                                </Form.Group>
                            </Col>


                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Shipper</Form.Label>
                                    <Form.Control type="text" autoComplete="" value={NowFinalDestination ? NowFinalDestination : finalDestinationOn == false ? finalDestination : ''} onChange={e => finalDestinationVal(e.target.value)} placeholder="" name="BlNo" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Row>
                                        <Col>
                                            <Form.Label>Consignee
                                            </Form.Label></Col>
                                        <Col>
                                            <Form.Check
                                                value="design"
                                                type="radio"
                                                aria-label="radio 1"
                                                label="Print in DO"
                                            />
                                        </Col>
                                    </Row>
                                    <Form.Control as="textarea" value={nowConsignee ? nowConsignee : consigneeOn == false ? consignee : ''} onChange={e => consigneeVal(e.target.value)} placeholder="" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Row>
                                        <Col>
                                            <Form.Label>
                                                Notify Party
                                            </Form.Label></Col>
                                        <Col>
                                            <Form.Check
                                                value="design"
                                                type="radio"
                                                aria-label="radio 1"
                                                label="Print in DO"
                                            />
                                        </Col>
                                    </Row>
                                    <Form.Control as="textarea" value={nowNotyfyParty ? nowNotyfyParty : notyfyPartyOn == false ? notyfyParty : ''} onChange={e => notyfyPartyVal(e.target.value)} placeholder="" />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            
                            <Col>
                                <Form.Group className="mb-3">
                                    <Row>
                                        <Col>
                                            <Form.Label>
                                                Notify Party 2
                                            </Form.Label></Col>
                                        <Col>
                                            <Form.Check
                                                value="design"
                                                type="radio"
                                                aria-label="radio 1"
                                                label="Print in DO"
                                            />
                                        </Col>
                                    </Row>
                                    <Form.Control as="textarea" value={nowNotyfyParty ? nowNotyfyParty : notyfyPartyOn == false ? notyfyParty : ''} onChange={e => notyfyPartyVal(e.target.value)} placeholder="" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Row>
                                        <Col>
                                            <Form.Label>
                                                Mark & No
                                            </Form.Label></Col>
                                        <Col>
                                            <Form.Check
                                                value="design"
                                                type="radio"
                                                aria-label="radio 1"
                                                label="Print in DO"
                                            />
                                        </Col>
                                    </Row>
                                    <Form.Control as="textarea" value={nowNotyfyParty ? nowNotyfyParty : notyfyPartyOn == false ? notyfyParty : ''} onChange={e => notyfyPartyVal(e.target.value)} placeholder="" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Row>
                                        <Col>
                                            <Form.Label>
                                                Remark
                                            </Form.Label></Col>
                                        <Col>
                                            <Form.Check
                                                value="design"
                                                type="radio"
                                                aria-label="radio 1"
                                                label="Print in DO"
                                            />
                                        </Col>
                                    </Row>
                                    <Form.Control as="textarea" value={nowNotyfyParty ? nowNotyfyParty : notyfyPartyOn == false ? notyfyParty : ''} onChange={e => notyfyPartyVal(e.target.value)} placeholder="" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                  <Form.Label> Goods Discription </Form.Label>
                                  <Form.Control as="textarea" value={nowNotyfyParty ? nowNotyfyParty : notyfyPartyOn == false ? notyfyParty : ''} onChange={e => notyfyPartyVal(e.target.value)} placeholder="" />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Gross Weight(KGS)</Form.Label>
                                    <Form.Control type="text" placeholder="" value={nownoOfCont ? nownoOfCont : noOfContOn == false ? noOfCont : ''} onChange={e => noOfContVal(e.target.value)} autoComplete="off" name="date" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Measurement(M3)</Form.Label>
                                    <Form.Control type="text" autoComplete="" value={nowmesurement ? nowmesurement : mesurementOn == false ? mesurement : ''} onChange={e => mesurementVal(e.target.value)} placeholder="" name="Vessel" />
                                </Form.Group>
                            </Col>

                            <Col className="text-center"> <Form.Label >Service</Form.Label></Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Orgin</Form.Label>
                                    <Form.Select aria-label="" onChange={e => { selectBooking(e.target.value) }}>
                                        <option value=""></option>
                                        <>
                                            {
                                                Array.isArray(blNumList) ? blNumList.map((bLItem, id) => (
                                                    <option value={bLItem.id} key={bLItem.id}>{bLItem.BLNo}</option>

                                                )) : ''
                                            }
                                        </>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Destination</Form.Label>
                                    <Form.Select aria-label="" onChange={e => { selectBooking(e.target.value) }}>
                                        <option value=""></option>
                                        <>
                                            {
                                                Array.isArray(blNumList) ? blNumList.map((bLItem, id) => (
                                                    <option value={bLItem.id} key={bLItem.id}>{bLItem.BLNo}</option>

                                                )) : ''
                                            }
                                        </>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                        
                    </Form>
                </Col>
            </Row>
        </Container>

    );

}

export default ManifestDetails;